import { useState } from 'react'
import '../assets/styles/Login.css'
import { useNavigate } from 'react-router-dom'
// import ReCAPTCHA from 'react-google-recaptcha' // reCAPTCHA desativado

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export default function Login() {
  const [email, setEmail] = useState('')
  const [senha, setSenha] = useState('')
  const [mensagem, setMensagem] = useState('')
  // Estados do reCAPTCHA - desativados
  // const [tentativasFalhas, setTentativasFalhas] = useState(0)
  // const [mostrarRecaptcha, setMostrarRecaptcha] = useState(false)
  // const [recaptchaToken, setRecaptchaToken] = useState(null)
  const navigate = useNavigate()
  // const recaptchaRef = useRef(null) // reCAPTCHA desativado

  const handleLogin = async (e) => {
    e.preventDefault()

    // reCAPTCHA desativado - código comentado para futura ativação
    // if (mostrarRecaptcha && !recaptchaToken) {
    //   setMensagem('Por favor, complete a verificação de segurança.')
    //   return
    // }

    try {
      const res = await fetch(`${API_BASE_URL}/usuarios/`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
      });

      const data = await res.json();

      if (!res.ok || !data.productId) {
        setMensagem('⚠️ Erro ao conectar com o servidor')
        return;
      }

      // Buscar usuário pelo email e validar senha
      const usuario = data.productId.find(user => 
        user.email === email && user.senha_hash === senha && user.ativo === 's'
      );

      if (!usuario) {
        setMensagem('❌ Credenciais inválidas ou usuário inativo')
        
        // Código reCAPTCHA desativado
        // const novasTentativas = tentativasFalhas + 1
        // setTentativasFalhas(novasTentativas)
        // if (novasTentativas >= 2) {
        //   setMostrarRecaptcha(true)
        // }
        // if (mostrarRecaptcha && recaptchaRef.current) {
        //   recaptchaRef.current.reset()
        //   setRecaptchaToken(null)
        // }
      } else {
        setMensagem('✅ Login realizado com sucesso!')
        console.log('Usuário logado:', usuario)
        
        // Salvar dados do usuário no localStorage
        localStorage.setItem('usuario', JSON.stringify({
          id: usuario.id,
          nome: usuario.nome,
          email: usuario.email,
          perfil: usuario.perfil
        }));
        
        // Código reCAPTCHA desativado
        // setTentativasFalhas(0)
        // setMostrarRecaptcha(false)
        // setRecaptchaToken(null)
        
        navigate('/') // redireciona
      }
    } catch (error) {
      setMensagem('🔌 Erro de conexão: ' + error.message)
    }
  }

  // Função para lidar com o reCAPTCHA - desativada
  // const handleRecaptchaChange = (token) => {
  //   setRecaptchaToken(token)
  // }

  // Novo handler para resetar senha
  const handleResetPassword = async () => {
   navigate('/RecuperarSenha') // redireciona
  }

  return (
    <div className='body-login'>
      <form className='Box-Login' onSubmit={handleLogin}>
        <h1>LOGIN</h1>
        <img src='/assets/images/logo.jpg' className='img-logo' alt='logo' />

        <p>Email</p>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Digite seu email"
          required
        />

        <p>Senha</p>
        <input
          type="password"
          value={senha}
          onChange={(e) => setSenha(e.target.value)}
          placeholder="Digite sua senha"
          required
        />
         
        {/* reCAPTCHA desativado - código comentado para futura ativação */}
        {/* {mostrarRecaptcha && (
          <div className="recaptcha-container">
            <ReCAPTCHA
              ref={recaptchaRef}
              sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY || "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI"}
              onChange={handleRecaptchaChange}
              theme="light"
            />
          </div>
        )} */}
         
         <button
          type="button"
          onClick={handleResetPassword}
          className='resetButton'
        >
          Esqueci a senha
        </button>
        <button type="submit" className='login-button'>Entrar</button>

        {/* Avisos do reCAPTCHA desativados */}
        {/* {tentativasFalhas > 0 && tentativasFalhas < 2 && (
          <div className="attempts-warning">
            Tentativa {tentativasFalhas} de 2. Após 2 tentativas será necessário completar a verificação de segurança.
          </div>
        )}

        {mostrarRecaptcha && (
          <div className="security-warning">
            Por favor, complete a verificação de segurança acima para continuar.
          </div>
        )} */}

        {mensagem && (
          <p style={{ color: mensagem.startsWith('Erro') ? 'red' : 'green' }}>
            {mensagem}
          </p>
        )}
      </form>
    </div>
  )
}
